import { useEffect, useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { useNavigate } from "react-router-dom";
import { API } from "../config";
import { Menu } from "../components/ui/menu";
import { decodeJwtPayload } from "../helpers/jwt";
import { useProfile } from "../context/ProfileContext";
import CollapsibleCard from "../components/ui/accordion";
import { cleanUp } from "../helpers/logout";
import Impersonate from "../components/ui/impersonate";

const i18n: Record<string, string> = {
  "Газ": "Газ",
  "Дачник сезонник": "Дачник сезонник",
  "Приезжают": "Приїжджають",
  "Общая площадь": "Загальна площа",
  "Счетчик на фасаде": "Лічильник на фасаді",
  "Счетчик на столбе": "Лічильник на стовпі",
  "Отапливаемая площадь": "Опалювана площа",
  "Живут": "Живуть",
  "Жилая площадь": "Житлова площа",
  "К-во фаз": "К-ть фаз",
  "Договор на поставку эл.энергии": "Договір на постачання ел.енергії",
  "Сдают постоянно": "Здають постійно",
  "number_of_registered": "Кількість зареєстрованих",
  "number_of_residents": "Кількість мешканців",
}

export default function ProfilePage() {
  const [isAdmin, setIsAdmin] = useState<Boolean>(false);

  const navigate = useNavigate();

  const { loading, token } = useProfile();
  const [profile, setProfile] = useState<any>();
  const [roles, setRoles] = useState<Array<string>>();
  const [telegram, setTelegram] = useState("");
  const [telegramSend, setTelegramSend] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [impersonate, setImpersonate] = useState<string>("");
  const [impersonateMessage, setImpersonateMessage] = useState<string>("");
  const [showLoading, setShowLoading] = useState<Boolean>(false);


  const t = (key: string) => {
    const translation = i18n[key];
    return translation ? translation : key;
  }

  useEffect(() => {
    setShowLoading(loading);
  }, [loading]);

  useEffect(() => {
    let impersonate: string | null = null;
    try {
      impersonate = localStorage.getItem("impersonate");
    } catch (e) {
      console.error("Error reading impersonate from localStorage:", e);
      impersonate = null; // Default to null if there's an error
    }
    if (impersonate) {
      setImpersonate(impersonate);
      setImpersonateMessage(`Обліковий запис ${impersonate}`);
    }
  }, []);

  useEffect(() => {
    if (roles && roles.includes("ADMIN")) {
      setIsAdmin(true);
    }
  }, [roles]);

  useEffect(() => {
    if (!token) {
      navigate("/login" + window.location.search);
      return;
    }

    try {
      setShowLoading(true);
      const params = new URLSearchParams();
      let impersonate: string | null = null;
      try {
        impersonate = localStorage.getItem("impersonate");
      } catch (e) {
        console.error("Error reading impersonate from localStorage:", e);
        impersonate = null; // Default to null if there's an error
      }
      if (impersonate) {
        setImpersonate(impersonate);
        params.append("i", impersonate);
      }
      fetch(API.PROFILE + `${params ? "?" + params : ""}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            cleanUp()
            navigate("/login" + window.location.search);
          } else {
            setProfile(data);
            setRoles(data?.roles || []);
            setTelegram(data.telegram || "");
            setTelegramSend(data.telegramSend);

            const tokenData = decodeJwtPayload(token)
            const id = tokenData.identifier;
          }
        }).catch((err) => {
        setError(`Помилка сервера ${err}`);
        setTimeout(() => setError(""), 5000);
      }).finally(() => {
        setShowLoading(false);
      });
    } catch (err) {
      setError("Помилка сервера");
      setTimeout(() => setError(""), 5000);
      setShowLoading(false);
    }
  }, [token, navigate]);

  if (showLoading) return <Menu><p className="text-center p-4">Завантажується...</p></Menu>;

  return (
    <Menu>
      <div className="flex flex-col pr-2 pb-2">
        <Impersonate message={impersonateMessage} callbackExit={() => {
          try {
            localStorage.removeItem("impersonate");
          } catch (e) {
            console.error("Error removing impersonate from localStorage:", e);
          }
          setImpersonateMessage("");
          navigate("/users");
        }}/>
        <Card className="w-full max-w-xl mb-6 rounded-2xl shadow-lg">
          <CardContent>
            <h1 className="text-2xl font-semibold mb-6 text-center">Садівник</h1>
            {/*<p className="text-center text-gray-600 mb-4"><strong>Roles:</strong> {profile?.roles?.join(", ")}</p>*/}

            {error && <p className="text-red-500 text-sm text-center">{error}</p>}
            {success && <p className="text-green-600">{success}</p>}

            <div className="space-y-4">

              {profile && (
                <CollapsibleCard title={`${profile?.name}`} open={true} key={`tariff-${profile?.account}`} more={false}>
                  <div className={"w-full border-b border-gray-200 mb-1 grid grid-cols-2 gap-y-2 gap-x-4"}>
                    <div className="font-medium">Особистий рахунок (О/р):</div>
                    <div className="text-left">{profile?.account}</div>

                    <div className="font-medium">Адреса:</div>
                    <div className="text-left">{profile?.address}</div>

                    <div className="font-medium">Телефон:</div>
                    <div className="text-left">{profile?.phones?.main || ''}</div>

                    <div className="font-medium">СТ:</div>
                    <div className="text-left">{profile?.section || ''}</div>

                    <div className="font-medium">Трансформатор(и):</div>
                    <div className="text-left space-x-1">
                      {Object.keys(profile?.transformers || {})?.map((transformerNr) => (
                        <span key={`${profile?.account}-${transformerNr}`}>{transformerNr}</span>
                      ))}
                    </div>
                  </div>
                </CollapsibleCard>
              )}

              <div className="flex items-center gap-4">
                <div>
                  <span className="text-sm font-medium">Telegram: {telegram}</span>
                </div>
              </div>

              {error && <p className="text-red-500 text-sm text-center">{error}</p>}
              {success && <p className="text-green-600">{success}</p>}
            </div>
          </CardContent>
        </Card>
      </div>
    </Menu>
  );
}
